<template>
  <div class="timeLinePage" @scroll="scrollT($event)" ref="timeLinePage">
       <div class="subPage">
           <div class="timeLine">
               <div class="timeItem"  v-for="(item,index) in listInfo"  :key="index" @click="choiceYear(index)">
                   <div class="year"  :class="index == currentIndex?'activeYear':''">{{item.year}}</div>
                   <div class="yearLine" :class="index == currentIndex?'activeLine':''"></div>
               </div>
           </div>
           <div class="content">
               <img class="contentImg" v-if="listInfo[currentIndex]" :src="listInfo[currentIndex].img_src"  alt="">
               <div class="textCon" v-if="listInfo[currentIndex]">
                    <div class="textTitle" >{{listInfo[currentIndex].title}}</div>
                    <div class="textLine"></div>
                    <div class="subTitle">{{listInfo[currentIndex].desc}}</div>
                    <!-- <div class="textContent" v-if="listInfo[currentIndex]" v-html="listInfo[currentIndex].content"></div> -->
               </div>
           </div>
       </div>
        <div style="height: 20px;"></div>
        <div class="footerCon"  ref="footerCon" v-show="footerShow">
			<div style="padding-top: 5px;padding-bottom: 5px;margin-right: 24px;"><a href='https://218.26.86.27:8067/ei/Ei!certificate.action?id=9028ffb17604406e01761864b3aa0010' target='_blank' style='border:0;height: 36px;'><img src='../../assets/image/shichang.png' style='border:0;height: 100%;width: 100%;'/></a></div>
            <div class="address"><img src="../../assets/image/address.png" alt=""><div>{{$t('language.address_b')}}：山西省/晋中市/平遥县/顺城路/故宫文创</div></div>
            <div class="email"><img src="../../assets/image/email.png" alt=""><div>{{$t('language.emails')}}：{{info.email}}</div></div>
        </div>
        <Fixed :goTop="gotoT"></Fixed>
  </div>
</template>
<script>
import Fixed from '../../components/fixed.vue';
export default {
    name:'pingyaoShow',
    data(){
        return {
           currentIndex:0,
           listInfo:[],
           scroll:'',
           footerShow:false,
           info:{}
        }
    },
    components:{
       Fixed
    },
    mounted(){
        // 侧边菜单显示
        let fixCon = document.getElementsByClassName("fixed")[0]; 
        fixCon.style.opacity = "1";


        this.getInfo();
        let timeLinePage = document.getElementsByClassName("timeLinePage")[0].clientHeight;
        let subPage = document.getElementsByClassName("subPage")[0].scrollHeight;
        let contentH = subPage - timeLinePage;
        if(contentH>0){
            this.footerShow = false;
        }else{
            this.footerShow = true;
        }
        this.$fetch('/index/info').then(res => {
            this.info = res.data;
        })
    },
    methods:{
       // 底部显示
       scrollT(event){
           let scrollBottom = event.target.scrollHeight -  event.target.scrollTop - event.target.clientHeight;
           if(scrollBottom <=0){
             this.footerShow = true;
           }else{
             this.footerShow = false;
           }
       },
       // 获取初始化数据
       getInfo(){
        this.$fetch('Content/getHistoryShow').then(res => {
            if(res.code == 200){
                this.listInfo = res.data.info;
            }
        })
        },
        // 选择年份
        choiceYear(index){
           this.currentIndex = index;
        },
        // 顶部
       gotoT(){
          this.$refs.timeLinePage.scrollTop = 0;
       }
    }
}
</script>
<style scoped>
.timeLinePage{
    width: 100%;
    height: 80vh;
    overflow-y: auto;
    font-family: Microsoft YaHei;
}
.timeLine{
    margin-top: 40px;
    width: 12.5%;
    margin-right: 12%;
    padding-bottom: 10px;
    height: 750px;
    overflow-y:auto;
}
.subPage{
    width: 100%;
   display: inline-flex;
}
.timeItem{
    text-align: right;
}
.year{
    width: 84px;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #151313;
    opacity: 0.8;
    padding:8px 0px;
}
.activeYear{
    font-size: 46px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #AF011A;
    transition: all 0.5s;
    width: 147px;
}
.yearLine{
    width: 84px;
    height: 4px;
    background: #000000;
    opacity: 0.5;
}
.activeLine{
    width: 147px;
    height: 4px;
    background: #AF011A;
    transition: all 1s;
}
/* .content img{
   position: absolute; top: 50%; left: 50%; display: block; min-width: 100%; min-height: 100%; transform:translate(-50%,-50%)
} */
.contentImg{
    width: 667px;
    /* width: 36%; */
    height: auto;
    float: left;
}
.content{
    width: 76%;
    margin-top: 100px;
    /* display: flex; */
}
.textCon{
    margin-left: 10px;
    text-align: center;
    margin-top: 112px;
    float: left;
}
.footerCon{
    width: 100%;
    height: 42px;
    background: rgba(245, 245, 245, 1);
    position: absolute;
    bottom: 0%;
    font-size: 14px;
    font-weight: bold;
    color: #3D3D3B;
    display: flex;
    justify-content: center;
}
.footerCon>div{
    display: flex;
    align-items: center;
}
.address{
    margin-right: 100px;
}
.address img{
    width: 20px;
    height: 22px;
    margin-right: 10px;
}
.email img{
    width: 19px;
    height: 14px;
    margin-right: 10px;
}
.textTitle{
    font-size: 24px;
    font-weight: bold;
    color: #141212;
}
.textLine{
    width: 49px;
    height: 4px;
    background: #000000;
    margin:10px auto;
}
.subTitle{
    font-size: 43px;
    font-weight: bold;
    color: #141212;
}
.textContent{
    width: 100%;
    font-size: 16px;
    font-weight: 400;
    color: #100F0F;
    line-height: 26px;
    margin-top: 30px;
    text-align: left;
    font-family: Microsoft YaHei;
    height: 350px;
    overflow-y: scroll;
}
</style>


// WEBPACK FOOTER //
// src/pages/newPage/timeLine.vue